import axios from 'axios';
import React, { useState } from 'react'
import cookies from 'js-cookie';
import jwt_decode from "jwt-decode";
const AuthContext = React.createContext({
    token: "",
    isLoggedIn: false,
    role: "",
    email: "",
    displayname: "",
    Login: (token:any) => {},
    Logout: () => { }
})


let logoutTimer:any = null ;

const calculateRemainingTime = (remainingTime: number) => {
    const currentTime = new Date().getTime();
    const expirationTime = new Date(remainingTime).getTime();
    console.log(expirationTime - currentTime)
    return expirationTime - currentTime;
}
export const AuthContextProvider = (props:any) => {

    const [token, setToken] = useState<any>(cookies.get("jwt"));
    let email = ""
    let displayName = ""
    let Role = ""
    axios.defaults.headers.common["jwt"] = token;

    const LogoutHandler = () => {
        setToken(null);
        cookies.set("jwt", "");
        if(logoutTimer){
            clearTimeout(logoutTimer);
        }
        // console.log(window.location)
        
        window.location.replace(window.location.origin +"/courses");
    }


    const setTokenExpiration = (token:any)=>{
        let decoded: any = jwt_decode(token) 
        console.log(decoded);
       email = decoded.data.user.email;
       displayName = decoded.data.user.displayname;
       Role = decoded.data.user.role_id == 1 ? "admin" : "student";
       console.log(displayName)
        let remainingTime = calculateRemainingTime(decoded.exp * 1000);
       logoutTimer=  setTimeout(LogoutHandler, remainingTime)
    }
    if (token) {   
       setTokenExpiration(token)
    }


    const LoginHandler = (token:any) => {
        setToken(token);
        cookies.set("jwt", token);
        axios.defaults.headers.common["jwt"] = token;
        setTokenExpiration(token)
        window.location.reload();
    }
    const userIsLoggedIn = !!token;

    const contextValue :any = {
        token: token,
        isLoggedIn: userIsLoggedIn,
        email: email,
        displayname: displayName,
        role: Role,
        Login: LoginHandler,
        Logout: LogoutHandler
    }

    return <AuthContext.Provider value={contextValue}> {props.children} </AuthContext.Provider>;
};



export default AuthContext